export default "__VITE_ASSET__DIojYXwy__"